export default function ({ app, route, redirect }) {
  // Check if the route doesn't already have openExternalBrowser query param
  if (!('openExternalBrowser' in route.query)) {
    redirect({ path: route.path, query: { ...route.query, openExternalBrowser: '1' } });
  }
}